// extracted by mini-css-extract-plugin
export default {"itemsList":"MX99plUTt0osEadPpJ9S","divider":"zYMbibS2bJs0jFxCJFs6"};